(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["clic35-community"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('clic35-review-diary')) {
    customElements.define('clic35-review-diary', class extends HTMLElement {
      connectedCallback() {
        this.initFrame = requestAnimationFrame(() => this.initialize());
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.initFrame);
        cancelAnimationFrame(this.scrollFrame);
        this.controller?.abort();
        this.observer?.disconnect();
      }
      initialize() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.rail = this.querySelector('.c35reviews-rail');
        this.cards = Array.from(this.querySelectorAll('[data-review-card]'));
        if (!this.rail || !this.cards.length) return;
        this.previous = this.querySelector('[data-review-prev]');
        this.next = this.querySelector('[data-review-next]');
        this.controls = this.querySelector('.c35reviews-controls');
        this.addEventListener('click', event => {
          const button = event.target.closest('button');
          if (!button || !this.contains(button)) return;
          if (button.hasAttribute('data-review-prev')) this.move(-1);
          if (button.hasAttribute('data-review-next')) this.move(1);
          if (button.hasAttribute('data-review-more')) {
            const card = button.closest('[data-review-card]');
            const expanded = !card.hasAttribute('data-expanded');
            card.toggleAttribute('data-expanded', expanded);
            button.setAttribute('aria-expanded', String(expanded));
            button.textContent = expanded ? 'Réduire' : 'Lire la suite';
            button.setAttribute('aria-label', expanded ? 'Réduire cet avis' : 'Lire la suite de cet avis');
          }
        }, { signal });
        this.rail.addEventListener('scroll', () => {
          cancelAnimationFrame(this.scrollFrame);
          this.scrollFrame = requestAnimationFrame(() => this.updateNavigation());
        }, { signal, passive: true });
        this.rail.addEventListener('keydown', event => {
          if (event.target !== this.rail) return;
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); this.move(event.key === 'ArrowRight' ? 1 : -1); }
          if (event.key === 'Home' || event.key === 'End') { event.preventDefault(); this.goTo(event.key === 'Home' ? 0 : this.cards.length - 1); }
        }, { signal });
        this.addEventListener('shopify:block:select', event => {
          const index = this.cards.findIndex(card => card.dataset.blockId === event.detail.blockId);
          if (index >= 0) this.goTo(index, true);
        }, { signal });
        this.observer = new ResizeObserver(() => { this.updateNavigation(); this.updateReviews(); });
        this.observer.observe(this.rail);
        this.setAttribute('data-ready', '');
        this.updateNavigation();
        this.updateReviews();
      }
      updateReviews() {
        // Measure every review before changing any card's layout.
        const measurements = this.cards.map(card => {
          const review = card.querySelector('[data-review-text]');
          const button = card.querySelector('[data-review-more]');
          if (!review || !button) return null;
          const lineHeight = parseFloat(getComputedStyle(review).lineHeight);
          return { card, button, long: review.scrollHeight > lineHeight * 10 + 2 };
        }).filter(Boolean);
        measurements.forEach(({ card, button, long }) => {
          if (card.hasAttribute('data-collapsible') !== long) card.toggleAttribute('data-collapsible', long);
          if (button.hidden === long) button.hidden = !long;
          if (!long) {
            card.removeAttribute('data-expanded');
            button.setAttribute('aria-expanded', 'false');
            if (button.textContent !== 'Lire la suite') button.textContent = 'Lire la suite';
          }
        });
      }
      updateNavigation() {
        if (!this.controls) return;
        const width = this.rail.clientWidth;
        const scrollWidth = this.rail.scrollWidth;
        const left = this.rail.scrollLeft;
        this.controls.hidden = scrollWidth <= width + 2;
        this.previous.disabled = left <= 2;
        this.next.disabled = left + width >= scrollWidth - 2;
      }
      move(direction) {
        const railRect = this.rail.getBoundingClientRect();
        const start = railRect.left + (parseFloat(getComputedStyle(this.rail).scrollPaddingLeft) || 0);
        let nearest = 0;
        let distance = Infinity;
        this.cards.forEach((card, index) => {
          const delta = Math.abs(card.getBoundingClientRect().left - start);
          if (delta < distance) { nearest = index; distance = delta; }
        });
        const perPage = matchMedia('(min-width: 900px)').matches ? 3 : 1;
        this.goTo(Math.max(0, Math.min(this.cards.length - 1, nearest + direction * perPage)));
      }
      goTo(index, instant = false) {
        if (!this.cards[index]) return;
        const railRect = this.rail.getBoundingClientRect();
        const cardRect = this.cards[index].getBoundingClientRect();
        const padding = parseFloat(getComputedStyle(this.rail).scrollPaddingLeft) || 0;
        const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.rail.scrollTo({ left: this.rail.scrollLeft + cardRect.left - railRect.left - padding, behavior: instant || reduced ? 'instant' : 'smooth' });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clic35-final"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('clic35-final')) {
    customElements.define('clic35-final', class extends HTMLElement {
      connectedCallback() {
        this.link = this.querySelector('[data-purchase-link]');
        this.link?.addEventListener('click', this.returnToPurchase);
      }
      disconnectedCallback() {
        this.link?.removeEventListener('click', this.returnToPurchase);
      }
      returnToPurchase = (event) => {
        if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        const target = document.getElementById(this.link.getAttribute('href').slice(1));
        if (!target) return;
        const choice = target.querySelector('input[data-color="true"]:checked') || target.querySelector('input[data-option-id]:checked');
        const destination = choice?.closest('fieldset') || target;
        const headerHeight = document.getElementById('header-component')?.getBoundingClientRect().height || 0;
        let scroller = destination.parentElement;
        while (scroller && !(scroller.scrollHeight > scroller.clientHeight && /auto|scroll/.test(getComputedStyle(scroller).overflowY))) {
          scroller = scroller.parentElement;
        }
        const scrollRoot = scroller || window;
        const currentTop = scroller ? scroller.scrollTop : window.scrollY;
        const rootTop = scroller ? scroller.getBoundingClientRect().top : 0;
        event.preventDefault();
        choice?.focus({ preventScroll: true });
        scrollRoot.scrollTo({
          top: Math.max(0, currentTop + destination.getBoundingClientRect().top - rootTop - headerHeight - 20),
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
        });
      };
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clic35-how-it-works"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('clic35-how-cards')) {
    customElements.define('clic35-how-cards', class extends HTMLElement {
      connectedCallback() {
        this.loadNearbyMedia();
        this.initFrame = requestAnimationFrame(() => this.initialize());
      }
      loadNearbyMedia() {
        this.mediaObserver?.disconnect();
        const templates = Array.from(this.querySelectorAll('template[data-c35-deferred-media]'));
        if (!templates.length) return;
        const reveal = () => {
          templates.forEach(template => template.replaceWith(template.content.cloneNode(true)));
          this.mediaObserver?.disconnect();
        };
        if (!('IntersectionObserver' in window)) { reveal(); return; }
        this.mediaObserver = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) reveal();
        }, { rootMargin: '600px 0px' });
        this.mediaObserver.observe(this);
      }
      disconnectedCallback() {
        this.mediaObserver?.disconnect();
        cancelAnimationFrame(this.initFrame);
        cancelAnimationFrame(this.scrollFrame);
        this.controller?.abort();
        this.observer?.disconnect();
      }
      initialize() {
        this.controller?.abort();
        this.observer?.disconnect();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.rail = this.querySelector('.c35how-rail');
        this.cards = Array.from(this.querySelectorAll('[data-how-card]'));
        this.dots = Array.from(this.querySelectorAll('[data-how-dot]'));
        if (!this.rail || !this.cards.length) return;
        this.active = 0;
        this.pointer = null;
        this.suppressUntil = 0;
        this.cards.forEach(card => this.setOpen(card, false));
        this.addEventListener('pointerdown', event => {
          this.pointer = { x: event.clientX, y: event.clientY };
          this.suppressUntil = 0;
        }, { signal, passive: true });
        this.addEventListener('pointermove', event => {
          if (this.pointer && Math.hypot(event.clientX - this.pointer.x, event.clientY - this.pointer.y) > 10) this.suppressUntil = Date.now() + 500;
        }, { signal, passive: true });
        const endPointer = () => { this.pointer = null; };
        this.addEventListener('pointerup', endPointer, { signal, passive: true });
        this.addEventListener('pointercancel', () => { this.suppressUntil = Date.now() + 500; endPointer(); }, { signal, passive: true });
        this.addEventListener('click', event => {
          const button = event.target.closest('button');
          if (!button || !this.contains(button)) return;
          if (event.detail && Date.now() < this.suppressUntil) return;
          if (button.hasAttribute('data-how-toggle')) {
            const card = button.closest('[data-how-card]');
            this.setOpen(card, !card.hasAttribute('data-open'));
          } else if (button.hasAttribute('data-how-dot')) {
            this.goTo(Number(button.dataset.howDot));
          }
        }, { signal });
        this.addEventListener('keydown', event => {
          if (event.key === 'Escape') {
            const card = event.target.closest('[data-how-card][data-open]');
            if (card) { this.setOpen(card, false); card.querySelector('[data-how-toggle]').focus({ preventScroll: true }); }
          }
          if (event.target !== this.rail) return;
          const moves = { ArrowRight: this.active + 1, ArrowLeft: this.active - 1, Home: 0, End: this.cards.length - 1 };
          if (event.key in moves) { event.preventDefault(); this.goTo(Math.max(0, Math.min(this.cards.length - 1, moves[event.key]))); }
        }, { signal });
        this.rail.addEventListener('scroll', () => {
          cancelAnimationFrame(this.scrollFrame);
          this.scrollFrame = requestAnimationFrame(() => this.updateActive());
        }, { signal, passive: true });
        this.addEventListener('shopify:block:select', event => {
          const index = this.cards.findIndex(card => card.dataset.blockId === event.detail.blockId);
          if (index < 0) return;
          this.setOpen(this.cards[index], false);
          this.goTo(index, true);
        }, { signal });
        this.observer = new ResizeObserver(() => this.updateActive());
        this.observer.observe(this.rail);
        this.setAttribute('data-ready', '');
        this.updateActive();
      }
      setOpen(card, open) {
        const front = card.querySelector('[data-how-front]');
        const detail = card.querySelector('[data-how-detail]');
        const button = card.querySelector('[data-how-toggle]');
        card.toggleAttribute('data-open', open);
        front.inert = open;
        front.setAttribute('aria-hidden', String(open));
        detail.inert = !open;
        detail.setAttribute('aria-hidden', String(!open));
        button.setAttribute('aria-expanded', String(open));
        button.setAttribute('aria-label', open ? button.dataset.closeLabel : button.dataset.openLabel);
      }
      goTo(index, instant = false) {
        if (!this.cards[index] || this.rail.scrollWidth <= this.rail.clientWidth) return;
        const card = this.cards[index].getBoundingClientRect();
        const rail = this.rail.getBoundingClientRect();
        const padding = parseFloat(getComputedStyle(this.rail).scrollPaddingLeft) || 0;
        const reduced = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.rail.scrollTo({ left: this.rail.scrollLeft + card.left - rail.left - padding, behavior: instant || reduced ? 'instant' : 'smooth' });
      }
      updateActive() {
        const rail = this.rail.getBoundingClientRect();
        const center = rail.left + rail.width / 2;
        let nearest = Infinity;
        this.cards.forEach((card, index) => {
          const rect = card.getBoundingClientRect();
          const distance = Math.abs(rect.left + rect.width / 2 - center);
          if (distance < nearest) { nearest = distance; this.active = index; }
        });
        this.dots.forEach((dot, index) => {
          if (index === this.active) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clic35-manifest"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('clic35-manifest')) {
    customElements.define('clic35-manifest', class extends HTMLElement {
      connectedCallback() {
        this.rail = this.querySelector('.c35manifest__rail');
        this.slides = [...this.querySelectorAll('.c35manifest__slide')];
        this.dots = [...this.querySelectorAll('.c35manifest__dot')];
        if (!this.rail || !this.dots.length) return;
        this.abort = new AbortController();
        const signal = this.abort.signal;
        this.desktop = window.matchMedia('(min-width: 900px)');
        this.reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.refresh = () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.update());
        };
        this.rail.addEventListener('scroll', this.refresh, { passive: true, signal });
        this.desktop.addEventListener('change', this.refresh, { signal });
        this.dots.forEach((dot, index) => dot.addEventListener('click', () => this.goTo(index), { signal }));
        this.addEventListener('shopify:block:select', event => {
          const slide = event.target.closest('.c35manifest__slide');
          if (slide) this.goTo(this.slides.indexOf(slide), true);
        }, { signal });
        this.resize = new ResizeObserver(this.refresh);
        this.resize.observe(this.rail);
        this.update();
      }
      update() {
        let active = 0;
        if (!this.desktop.matches) {
          const start = this.rail.getBoundingClientRect().left + parseFloat(getComputedStyle(this.rail).paddingLeft);
          let distance = Infinity;
          this.slides.forEach((slide, index) => {
            const delta = Math.abs(slide.getBoundingClientRect().left - start);
            if (delta < distance) { distance = delta; active = index; }
          });
        }
        this.dots.forEach((dot, index) => dot.setAttribute('aria-current', String(index === active)));
      }
      goTo(index, instant = false) {
        if (this.desktop.matches || !this.slides[index]) return;
        const padding = parseFloat(getComputedStyle(this.rail).paddingLeft);
        const left = this.rail.scrollLeft + this.slides[index].getBoundingClientRect().left - this.rail.getBoundingClientRect().left - padding;
        this.rail.scrollTo({ left, behavior: instant || this.reduced.matches ? 'instant' : 'smooth' });
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.resize?.disconnect();
        cancelAnimationFrame(this.frame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clic35-media-strip"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('clic35-media-loop')) {
    customElements.define('clic35-media-loop', class extends HTMLElement {
      connectedCallback() {
        if (!this.hasAttribute('data-c35-continuous')) return;
        this.frame = requestAnimationFrame(() => {
          if (!this.isConnected) return;
          const first = this.firstElementChild;
          const duplicate = first?.nextElementSibling;
          const belt = this.parentElement;
          if (!first || !duplicate || !belt) return;

          if (this.closest('[id*="clic35_media_strip_nMmtdk"]')) {
            this.querySelectorAll('.clic35-media-strip__logo').forEach(async (img) => {
              if (img.parentElement.classList.contains('nuki-logo-frame')) return;
              try {
                const source = new Image();
                source.crossOrigin = 'anonymous';
                source.src = img.currentSrc || img.src;
                await source.decode();
                if (!this.isConnected || !img.isConnected) return;
                const canvas = document.createElement('canvas');
                canvas.width = source.naturalWidth;
                canvas.height = source.naturalHeight;
                const context = canvas.getContext('2d', { willReadFrequently: true });
                context.drawImage(source, 0, 0);
                const { data } = context.getImageData(0, 0, canvas.width, canvas.height);
                let left = canvas.width, top = canvas.height, right = -1, bottom = -1;
                for (let y = 0; y < canvas.height; y++) {
                  for (let x = 0; x < canvas.width; x++) {
                    const i = (y * canvas.width + x) * 4;
                    if (data[i + 3] > 128 && Math.min(data[i], data[i + 1], data[i + 2]) < 200) {
                      left = Math.min(left, x); right = Math.max(right, x);
                      top = Math.min(top, y); bottom = Math.max(bottom, y);
                    }
                  }
                }
                if (right < left || bottom < top) return;
                const width = right - left + 1, height = bottom - top + 1;
                const frame = document.createElement('span');
                frame.className = 'nuki-logo-frame';
                frame.style.setProperty('--nuki-logo-ratio', width / height);
                frame.style.setProperty('--nuki-image-width', (canvas.width / width * 100) + '%');
                frame.style.setProperty('--nuki-image-height', (canvas.height / height * 100) + '%');
                frame.style.setProperty('--nuki-image-left', (-left / width * 100) + '%');
                frame.style.setProperty('--nuki-image-top', (-top / height * 100) + '%');
                img.before(frame);
                frame.append(img);
              } catch (_) {}
            });
          }

          const measure = () => {
            const width = parseFloat(getComputedStyle(first).width);
            const viewport = parseFloat(getComputedStyle(belt).width);
            if (!(width > 0) || !(viewport > 0)) return;
            const copies = Math.max(2, Math.ceil(viewport / width) + 1);
            while (this.children.length < copies) this.appendChild(duplicate.cloneNode(true));
            while (this.children.length > copies) this.lastElementChild.remove();
            this.style.setProperty('--c35-loop-width', `${width}px`);
          };
          this.observer = new ResizeObserver(measure);
          this.observer.observe(first);
          this.observer.observe(belt);
          measure();
        });
      }
      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clic35-results"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('clic35-results')) {
    customElements.define('clic35-results', class extends HTMLElement {
      connectedCallback() {
        this.loadNearbyMedia();
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const gallery = this.querySelector('.c35r-gallery');
        if (!gallery) return;
        const photos = [...gallery.querySelectorAll('.c35r-photo')];
        const dots = [...this.querySelectorAll('.c35r-dot')];
        const previous = this.querySelector('[data-c35r-prev]');
        const next = this.querySelector('[data-c35r-next]');
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        let active = 0;
        const positions = () => photos.map(photo => photo.offsetLeft - photos[0].offsetLeft);
        const update = () => {
          this.frame = null;
          const offsets = positions();
          active = offsets.reduce((best, value, index) => Math.abs(value - gallery.scrollLeft) < Math.abs(offsets[best] - gallery.scrollLeft) ? index : best, 0);
          dots.forEach((dot, index) => {
            if (index === active) dot.setAttribute('aria-current', 'true');
            else dot.removeAttribute('aria-current');
          });
          if (previous) previous.disabled = gallery.scrollLeft <= 2;
          if (next) next.disabled = gallery.scrollLeft + gallery.clientWidth >= gallery.scrollWidth - 2;
        };
        const schedule = () => { if (!this.frame) this.frame = requestAnimationFrame(update); };
        const go = (index, instant = false) => gallery.scrollTo({ left: positions()[Math.max(0, Math.min(index, photos.length - 1))], behavior: reduced.matches || instant ? 'instant' : 'smooth' });
        const move = direction => {
          const offsets = positions();
          const target = direction > 0 ? offsets.find(value => value > gallery.scrollLeft + 3) : [...offsets].reverse().find(value => value < gallery.scrollLeft - 3);
          gallery.scrollTo({ left: target ?? (direction > 0 ? gallery.scrollWidth : 0), behavior: reduced.matches ? 'instant' : 'smooth' });
        };
        previous?.addEventListener('click', () => move(-1), options);
        next?.addEventListener('click', () => move(1), options);
        dots.forEach((dot, index) => dot.addEventListener('click', () => go(index), options));
        gallery.addEventListener('scroll', schedule, { ...options, passive: true });
        gallery.addEventListener('keydown', event => {
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); move(event.key === 'ArrowRight' ? 1 : -1); }
          if (event.key === 'Home' || event.key === 'End') { event.preventDefault(); go(event.key === 'Home' ? 0 : photos.length - 1); }
        }, options);
        let drag = null;
        gallery.addEventListener('pointerdown', event => {
          if (event.pointerType !== 'mouse' || event.button !== 0) return;
          event.preventDefault();
          drag = { x: event.clientX, left: gallery.scrollLeft };
          gallery.setPointerCapture(event.pointerId);
          gallery.classList.add('is-dragging');
        }, options);
        gallery.addEventListener('pointermove', event => {
          if (!drag) return;
          gallery.scrollLeft = drag.left - (event.clientX - drag.x);
        }, options);
        const endDrag = event => {
          if (!drag) return;
          drag = null;
          gallery.classList.remove('is-dragging');
          if (gallery.hasPointerCapture(event.pointerId)) gallery.releasePointerCapture(event.pointerId);
          schedule();
        };
        gallery.addEventListener('pointerup', endDrag, options);
        gallery.addEventListener('pointercancel', endDrag, options);
        this.addEventListener('shopify:block:select', event => {
          const photo = event.target.closest('.c35r-photo');
          const index = photos.indexOf(photo);
          if (index >= 0) go(index, true);
        }, options);
        this.resizeObserver = new ResizeObserver(schedule);
        this.resizeObserver.observe(gallery);
        this.classList.add('c35r-ready');
        update();
      }
      loadNearbyMedia() {
        this.mediaObserver?.disconnect();
        const templates = Array.from(this.querySelectorAll('template[data-c35-deferred-media]'));
        if (!templates.length) return;
        const reveal = () => {
          templates.forEach(template => template.replaceWith(template.content.cloneNode(true)));
          this.mediaObserver?.disconnect();
        };
        if (!('IntersectionObserver' in window)) { reveal(); return; }
        this.mediaObserver = new IntersectionObserver(entries => {
          if (entries.some(entry => entry.isIntersecting)) reveal();
        }, { rootMargin: '600px 0px' });
        this.mediaObserver.observe(this);
      }
      disconnectedCallback() {
        this.mediaObserver?.disconnect();
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.frame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["clic35-sticky-cart"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('clic35-sticky-cart')) {
  customElements.define('clic35-sticky-cart', class extends HTMLElement {
    connectedCallback() {
      if (this.lifecycle) return;
      this.lifecycle = new AbortController();
      this.inert = true;
      this.frame = requestAnimationFrame(() => this.connect());
      document.addEventListener('shopify:section:load', () => this.connect(), { signal: this.lifecycle.signal });
      document.addEventListener('shopify:section:unload', () => this.queue(), { signal: this.lifecycle.signal });
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      clearTimeout(this.unlock);
      this.lifecycle?.abort(); this.lifecycle = null;
      this.binding?.abort(); this.observer?.disconnect(); this.intersection?.disconnect(); this.geometry?.disconnect(); this.overlays?.disconnect();
    }
    queue() {
      cancelAnimationFrame(this.frame);
      this.frame = requestAnimationFrame(() => { this.sync(); this.visibility(); });
    }
    connect() {
      this.binding?.abort(); this.observer?.disconnect(); this.intersection?.disconnect(); this.geometry?.disconnect(); this.overlays?.disconnect();
      this.main = document.querySelector('clic35-product[data-product-url]');
      this.primary = this.main?.querySelector('.c35-form .c35-cta');
      this.button = this.querySelector('.c35-sticky__button');
      if (!this.primary) { this.classList.remove('is-visible'); this.inert = true; return; }
      this.binding = new AbortController();
      const { signal } = this.binding;
      this.button.setAttribute('aria-controls', this.primary.form.getAttribute('id'));
      this.button.addEventListener('click', () => {
        this.sync();
        if (this.missing) {
          this.missing.scrollIntoView({ block: 'center', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
          this.missing.querySelector('input:not(:disabled)')?.focus({ preventScroll: true });
          return;
        }
        if (this.button.disabled || this.primary.disabled) return;
        this.locked = true;
        this.button.disabled = true;
        this.primary.click();
        clearTimeout(this.unlock);
        this.unlock = setTimeout(() => { this.locked = false; this.queue(); }, 600);
        this.queue();
      }, { signal });
      this.main.addEventListener('clic35:variant-change', () => this.queue(), { signal });
      this.main.addEventListener('change', () => this.queue(), { signal });
      this.observer = new MutationObserver(() => this.queue());
      this.observer.observe(this.main, { attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'aria-busy', 'value'], childList: true, subtree: true, characterData: true });
      this.intersection = new IntersectionObserver(() => this.visibility(), { threshold: [0, 1] });
      this.intersection.observe(this.primary);
      this.geometry = new ResizeObserver(() => this.queue());
      this.geometry.observe(this.main);
      this.overlays = new MutationObserver(records => {
        if (records.some(record => !this.contains(record.target))) this.queue();
      });
      this.overlays.observe(document.body, { attributes: true, attributeFilter: ['open', 'hidden', 'aria-hidden', 'style'], subtree: true });
      window.addEventListener('scroll', () => this.queue(), { signal, passive: true });
      window.addEventListener('resize', () => this.queue(), { signal, passive: true });
      document.addEventListener('close', () => this.queue(), { signal, capture: true });
      this.sync(); this.visibility();
    }
    visibility() {
      if (!this.primary?.isConnected) { this.classList.remove('is-visible'); this.inert = true; return; }
      const bottom = this.primary.getBoundingClientRect().bottom;
      const wasVisible = this.classList.contains('is-visible');
      const passed = bottom <= (wasVisible ? 0 : -8);
      const cookie = document.querySelector('#shopify-pc__banner');
      const cookieVisible = cookie && cookie.getClientRects().length && getComputedStyle(cookie).visibility !== 'hidden' && getComputedStyle(cookie).display !== 'none';
      const blocked = document.querySelector('dialog[open],theme-drawer[open],[role="dialog"][aria-modal="true"]:not([hidden]):not([aria-hidden="true"])') || cookieVisible;
      const visible = passed && !blocked;
      this.classList.toggle('is-visible', visible);
      this.inert = !visible;
    }
    sync() {
      if (!this.primary?.isConnected) {
        if (this.main?.isConnected && this.main.querySelector('.c35-form .c35-cta')) this.connect();
        return;
      }
      const form = this.primary.form;
      const commerce = this.main.querySelector('[data-commerce]');
      const id = form.querySelector('[name="id"]');
      const fields = [...this.main.querySelectorAll('[data-options] fieldset')];
      this.missing = fields.find(field => !field.querySelector('input:checked'));
      const values = fields.map(field => field.querySelector('input:checked')?.value);
      const variants = [...this.main.querySelectorAll('template[data-local-variant]')];
      const variant = variants.find(item => JSON.stringify(JSON.parse(item.dataset.options)) === JSON.stringify(values));
      const mismatch = variants.length && (!variant || variant.dataset.variant !== id?.value);
      const busy = this.locked || form.getAttribute('aria-busy') === 'true' || commerce?.getAttribute('aria-busy') === 'true';
      const unavailable = !this.missing && (mismatch || variant?.dataset.available === 'false' || this.primary.disabled || this.primary.getAttribute('aria-disabled') === 'true' || !id?.value || id.disabled);
      this.button.disabled = Boolean(busy || unavailable);
      this.button.setAttribute('aria-busy', String(Boolean(busy)));
      this.querySelector('[data-sticky-label]').textContent = busy ? 'Ajout en cours…' : (unavailable ? (this.main.querySelector('[data-cta-text]')?.textContent.trim() || 'Indisponible') : this.dataset.label);
      this.querySelector('.c35-sticky__status').textContent = this.main.querySelector('[data-error]')?.textContent || '';
      this.dataset.variant = id?.value || '';
      this.querySelector('[data-sticky-variant]').textContent = values.filter(Boolean).join(' · ');
      this.querySelector('[data-sticky-price]').textContent = commerce?.dataset.stickyPrice || '';
      const compare = this.querySelector('[data-sticky-compare]');
      compare.textContent = commerce?.dataset.stickyCompare || ''; compare.hidden = !compare.textContent;
      const source = commerce?.dataset.stickyImage;
      const image = this.querySelector('[data-sticky-image]');
      image.hidden = !source;
      if (source && image.getAttribute('src') !== source) image.src = source;
      this.querySelector('.c35-sticky__title').textContent = this.main.querySelector('h1')?.textContent.trim() || '';
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-announcements"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('clic35-announcements')) {
    customElements.define('clic35-announcements', class extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('.announcement-bar__slide')];
        this.index = 0;
        this.mobile = window.matchMedia('(max-width: 1023px)');
        this.update = () => {
          clearInterval(this.timer);
          this.slides.forEach((slide, index) => {
            const hidden = this.mobile.matches && index !== this.index;
            slide.setAttribute('aria-hidden', String(hidden));
            slide.inert = hidden;
          });
          this.dataset.ready = '';
          if (this.mobile.matches && this.slides.length > 1 && !document.hidden) {
            this.timer = setInterval(() => {
              this.index = (this.index + 1) % this.slides.length;
              this.update();
            }, Number(this.dataset.interval) || 4000);
          }
        };
        this.select = event => {
          const index = this.slides.findIndex(slide => slide === event.target || slide.contains(event.target));
          if (index >= 0) { this.index = index; this.update(); }
        };
        this.mobile.addEventListener('change', this.update);
        document.addEventListener('visibilitychange', this.update);
        this.addEventListener('shopify:block:select', this.select);
        this.update();
      }
      disconnectedCallback() {
        clearInterval(this.timer);
        this.mobile?.removeEventListener('change', this.update);
        document.removeEventListener('visibilitychange', this.update);
        this.removeEventListener('shopify:block:select', this.select);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nuki-photo-reviews"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('nuki-photo-reviews')) {
  customElements.define('nuki-photo-reviews', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.frame = requestAnimationFrame(() => this.initialize());
    }
    initialize() {
      if (!this.isConnected || this.abort) return;
      this.track = this.querySelector('.nuki-reviews__track');
      this.nav = this.querySelector('.nuki-reviews__nav');
      if (!this.track || !this.nav) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.quotes = [...this.querySelectorAll('.nuki-reviews__quote')].map(quote => ({ quote, full: quote.innerHTML, text: quote.textContent.trim(), button: quote.nextElementSibling, expanded: false }));
      this.update = () => {
        const cards = [...this.track.children];
        const max = this.track.scrollWidth - this.track.clientWidth;
        this.nav.hidden = max < 4 || matchMedia('(max-width:749px)').matches;
        const step = (cards[0]?.getBoundingClientRect().width || 1) + parseFloat(getComputedStyle(this.track).gap || 0);
        const index = Math.round(this.track.scrollLeft / step);
        this.querySelector('.nuki-reviews__position').textContent = `${index + 1} / ${cards.length}`;
        this.nav.querySelector('[data-direction="-1"]').disabled = this.track.scrollLeft < 4;
        this.nav.querySelector('[data-direction="1"]').disabled = this.track.scrollLeft >= max - 4;
      };
      this.measure = () => {
        const mobile = matchMedia('(max-width:749px)').matches;
        this.quotes.forEach(item => {
          if (item.expanded) return;
          item.quote.innerHTML = item.full;
          item.button.hidden = true;
          if (!mobile) return;
          const maxHeight = parseFloat(getComputedStyle(item.quote).lineHeight) * 4 + 1;
          if (item.quote.getBoundingClientRect().height <= maxHeight) return;
          const words = item.text.split(/\s+/);
          let lo = 0, hi = words.length;
          while (lo < hi) {
            const mid = Math.ceil((lo + hi) / 2);
            item.quote.textContent = words.slice(0, mid).join(' ') + '…';
            if (item.quote.getBoundingClientRect().height <= maxHeight) lo = mid;
            else hi = mid - 1;
          }
          item.quote.textContent = words.slice(0, lo).join(' ') + '…';
          item.button.hidden = false;
        });
        this.update();
      };
      this.nav.addEventListener('click', event => {
        const button = event.target.closest('button');
        if (!button || !this.track.children.length) return;
        const step = this.track.children[0].getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).gap || 0);
        this.track.scrollBy({ left: Number(button.dataset.direction) * step, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
      }, options);
      this.quotes.forEach(item => item.button.addEventListener('click', () => {
        item.expanded = !item.expanded;
        item.button.setAttribute('aria-expanded', String(item.expanded));
        item.button.textContent = item.expanded ? item.button.dataset.less : item.button.dataset.more;
        if (item.expanded) item.quote.innerHTML = item.full;
        else this.measure();
      }, options));
      this.track.addEventListener('scroll', this.update, { ...options, passive: true });
      this.addEventListener('shopify:block:select', event => {
        const card = event.target.closest('.nuki-reviews__card');
        if (card) this.track.scrollTo({ left: card.offsetLeft - this.track.children[0].offsetLeft, behavior: 'instant' });
      }, options);
      let previousWidth = 0;
      this.observer = new ResizeObserver(entries => {
        const width = entries[0].contentRect.width;
        if (width !== previousWidth) { previousWidth = width; this.measure(); }
      });
      this.observer.observe(this.track);
      document.fonts.ready.then(() => { if (this.isConnected) this.measure(); });
      this.measure();
    }
    disconnectedCallback() {
      this.quotes?.forEach(item => {
        item.quote.innerHTML = item.full;
        item.button.hidden = true;
        item.button.setAttribute('aria-expanded', 'false');
        item.button.textContent = item.button.dataset.more;
      });
      cancelAnimationFrame(this.frame); this.abort?.abort(); this.abort = null; this.observer?.disconnect();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
